// extracted by mini-css-extract-plugin
module.exports = {"route":"Legal_route__RczwF","container":"Legal_container__3wDNo"};